import styled from '@emotion/styled'

import { theme } from 'styles/theme/hav-theme'

export const StatisticsRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin: ${theme.spacing.sm} 0;
  gap: ${theme.spacing.sm};
`
export const InnerRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: ${theme.spacing.xm};
`
export const Box = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: start;
  gap: ${theme.spacing.xs};
`
export const BoxTitle = styled.span`
  display: block;
  color: ${theme.colors.neutral.medium};
  font-size: ${theme.typography.sizes.xs};
  font-weight: ${theme.typography.weight.lg};
`
export const BoxValue = styled.span`
  display: block;
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes.sm};
  font-weight: ${theme.typography.weight.xsm};
`
